import type { TodoTableRow } from '../../../core/utils/todoScheduleEvent';

export interface ChecklistPastDueFields {
	status?: string | { name?: string; label?: string } | null;
}

const normalizeChecklistStatus = (
	status: ChecklistPastDueFields['status'],
): string => {
	if (!status) return '';
	if (typeof status === 'string') return status.trim().toLowerCase();
	if (typeof status === 'object') {
		const value = status.name ?? status.label;
		return typeof value === 'string' ? value.trim().toLowerCase() : '';
	}
	return '';
};

export function isChecklistPastDue(item: ChecklistPastDueFields): boolean {
	return normalizeChecklistStatus(item.status) === 'overdue';
}

export function isTodoPastDue(todo: TodoTableRow): boolean {
	return Boolean(todo.pastDue);
}
